import styled from 'styled-components'

export const Img = styled.img`
    width: 100%;
    height: 600px;
    object-fit: cover;
    content: url(${props => props.imgBig});

    @media screen and (max-width: 1500px) {
        height: 480px;
        content: url(${props => props.img});
    }

    @media screen and (max-width: 768px) {
        height: 85vh;
        content: url(${props => props.imgSmall});
    }
`

export const DivTextSlider = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(70%,-50%);
    width: 500px;
    display: ${({ isHide }) => isHide ? 'none' : 'unset'};

    @media screen and (max-width: 1500px) {
        transform: translate(55%,-50%);
        width: 385px;
    }
  
    @media screen and (max-width: 768px) {
        width: 321px;
        top: 12px;
        left: 30px;
        transform: unset;
    }
`


const animation = `
  animation: 2s anim-lineUp ease-out;
  @keyframes anim-lineUp {
    0% {
      opacity: 0;
      transform: translateY(80%);
    }
    20% {
      opacity: 0;
    }
    50% {
      opacity: 1;
      transform: translateY(0%);
    }
    100% {
      opacity: 1;
      transform: translateY(0%);
    }
  }
`

export const SubText = styled.p`
    color: #fff;
    font-size: 25px;
    margin: 0;
    ${animation}

    @media screen and (max-width: 1500px) {
      font-size: 20px;
    }
  
    @media screen and (max-width: 768px) {
      font-size: 14px;
    }
`

export const TitleText = styled.h1`
    font-weight: bold;
    color: #fff;
    
    font-size: 35px;
    margin: 0;
    ${animation}

    @media screen and (max-width: 1500px) {
      font-size: 30px;
    }
  
    @media screen and (max-width: 768px) {
      font-size: 22px;
    }

    
`
